import {AnalysisMainViewItemType} from 'analysis-tool/ui/main-view/MainViewTypes';
import {
  LabAutomationFeature,
  InsightsFeature,
  RegistryFeature,
} from 'auth/capabilities/CapabilityFeatureConstants';
import {isConnectFeatureEnabled, isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';

import {DataFrameCreationMethod, DataFrameCreationMethodOptions} from './DataFrameCreationTypes';

export const DATA_FRAME_CREATION_METHOD_OPTIONS: {
  [key in DataFrameCreationMethod]: DataFrameCreationMethodOptions;
} = {
  [DataFrameCreationMethod.CONNECTION_DATA]: {
    icon: ModelTypeConstants.CONNECTION,
    initializationViewItem: {type: AnalysisMainViewItemType.CONNECTION_DATA_DATASET_CONFIGURATION},
    text: 'From connection',
    analyticsEventName: 'connection_data',
    isEnabled: () =>
      isConnectFeatureEnabled({feature: LabAutomationFeature.LAB_AUTOMATION_DISCOVER}) &&
      BenchlingConfig.ENABLE_ANALYSIS_TOOL_CONNECTION_DATASET_CREATION,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'connectionData'},
  },
  [DataFrameCreationMethod.DATA_CATALOG]: {
    icon: 'dataset',
    initializationViewItem: {type: AnalysisMainViewItemType.DATA_CATALOG_DATASET_CONFIGURATION},
    text: 'From dataset',
    analyticsEventName: 'data_catalog',
    isEnabled: () => BenchlingConfig.ENABLE_ANALYSIS_TOOL,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'dataCatalog'},
  },
  [DataFrameCreationMethod.INSIGHTS_BLOCK]: {
    icon: ModelTypeConstants.ANALYTICS_DASHBOARD,
    initializationViewItem: {type: AnalysisMainViewItemType.INSIGHTS_BLOCK_DATASET_CONFIGURATION},
    text: 'From dashboard query',
    analyticsEventName: 'insights_block',
    isEnabled: () => isFeatureEnabled({feature: InsightsFeature.INSIGHTS_DISCOVER}),
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'insightsBlock'},
  },
  [DataFrameCreationMethod.REGISTRY_SCHEMA]: {
    icon: ModelTypeConstants.REGISTRY,
    initializationViewItem: {type: AnalysisMainViewItemType.REGISTRY_SCHEMA_DATASET_CONFIGURATION},
    text: 'From Registry schema',
    analyticsEventName: 'registry_schema',
    isEnabled: () => isFeatureEnabled({feature: RegistryFeature.REGISTRY_DISCOVER}),
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'registrySchema'},
  },
  [DataFrameCreationMethod.UPLOAD_CSV]: {
    icon: 'upload',
    initializationViewItem: {type: AnalysisMainViewItemType.UPLOAD_CSV_DATASET_CONFIGURATION},
    text: 'From CSV',
    analyticsEventName: 'upload_csv',
    isEnabled: () => true,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'uploadCSV'},
  },
  [DataFrameCreationMethod.COMBINE_DATA_FRAMES]: {
    icon: 'merge',
    initializationViewItem: {type: AnalysisMainViewItemType.COMBINE_DATA_FRAMES},
    text: 'By combining tables',
    analyticsEventName: 'combine_data_frames',
    isEnabled: () => true,
    canReplace: true,
    dataTestAttrs: {component: 'DataFrameCreationMethod', element: 'combineTables'},
  },
};

export const ORDERED_DATA_FRAME_CREATION_METHODS: Array<DataFrameCreationMethod> = [
  DataFrameCreationMethod.INSIGHTS_BLOCK,
  DataFrameCreationMethod.REGISTRY_SCHEMA,
  DataFrameCreationMethod.DATA_CATALOG,
  DataFrameCreationMethod.CONNECTION_DATA,
  DataFrameCreationMethod.UPLOAD_CSV,
  DataFrameCreationMethod.COMBINE_DATA_FRAMES,
];

/** @package */
export const DATA_FRAME_CREATION_NO_PREVIEW_PLACEHOLDER_TEXT = 'No table preview available yet';
